import { createVNode as _createVNode } from "vue";
/**
 * @author xiezhixiong
 * @fileoverview 迷你的分页器
 */
import { defineComponent, ref, computed, watch } from "vue";
import useRespondTo from "@/hooks/common/respond-to";
export default defineComponent({
  name: 'MiniPagination',
  props: {
    /**
     * 数据总数
     */
    total: {
      type: Number,
      required: true
    },
    /**
     * 每页条数
     */
    pageSize: {
      type: Number,
      required: true
    },
    /**
     * 当前页数
     */
    current: {
      type: Number,
      required: true
    }
  },
  emits: ['change'],
  setup(props, {
    emit
  }) {
    const curPage = ref(1);
    const {
      isMobile
    } = useRespondTo();
    const items = computed(() => Array.from(new Array(Math.floor(props.total / props.pageSize)), (v, i) => i + 1));
    const triggerChange = newVal => {
      emit('change', newVal);
    };
    const handleNext = () => {
      if (curPage.value >= Math.floor(props.total / props.pageSize)) {
        return;
      }
      const nextVal = curPage.value + 1;
      if (!('current' in props)) {
        curPage.value++;
      }
      triggerChange(nextVal);
    };
    const handlePrev = () => {
      if (curPage.value <= 1) {
        return;
      }
      const nextVal = curPage.value - 1;
      if (!('current' in props)) {
        curPage.value--;
      }
      triggerChange(nextVal);
    };
    watch(() => props.current, newVal => curPage.value = newVal);
    return () => {
      return _createVNode("div", {
        "class": ['mini-pagination', isMobile.value ? 'mini-pagination-m' : '']
      }, [_createVNode("div", {
        "class": ['mini-pagination-prev', isMobile.value ? 'mini-pagination-m-prev' : ''],
        "onClick": handlePrev
      }, null), _createVNode("ul", {
        "class": "mini-pagination-indicator"
      }, [items.value.map(item => _createVNode("li", {
        "key": item,
        "class": ['mini-pagination-indicator-item', item === curPage.value ? 'mini-pagination-indicator-item__active' : '', isMobile.value && 'mini-pagination-m-indicator-item']
      }, null))]), _createVNode("div", {
        "class": ['mini-pagination-next', isMobile.value && 'mini-pagination-m-next'],
        "onClick": handleNext
      }, null)]);
    };
  }
});